export const MBLinking = {
  open: async (url: string): Promise<void> => {
    // TODO(fant): important - set up analytics for shared components
    // Segment.track('link', { url });
    window.open(url, '_blank');
  },
};
